module.exports = __webpack_public_path__ + "static/img/vouchers205.5e25cdd6.png";